export type ThreeProps = {
  camera: any;
  cameraDefault: number;
  cameraMax: number;
  cameraMin: number;
  canvasModel: any;
  contextGroup: any;
  controls: any;
  croppedImage: any;
  cntCurrent: any;
  defaultUnits: any;
  frameModel: any;
  lights: Array<any>;
  params: any;
  renderView: any;
  renderer: any;
  rotationLocked: boolean;
  scene: any;
  showDimensions: boolean;
};

const hostURL = `${window.location.origin}/`;
const mapleSettings = {
  face: {
    texFactor: 2,
    texOffset: [0, 0],
    texRepeat: [8, 0.5],
  },
  side: {
    texFactor: 1,
    texOffset: [0.1, 0.5],
    texRepeat: [18, 0.2],
  },
};

export const threeDefault: ThreeProps = {
  camera: null,
  cameraDefault: 4.5,
  cameraMax: 7.5,
  cameraMin: 1,
  canvasModel: null,
  cntCurrent: null,
  contextGroup: null,
  controls: null,
  croppedImage: null,
  defaultUnits: null,
  frameModel: null,
  lights: [],
  params: {
    autoZoom: 0,
    backgroundColor: "#ffffff",
    breakpoints: {
      medium: 40 * 40,
      small: 20 * 20,
    },
    camContextView: 0,
    camSideView: 0,
    camZoomView: 0,
    canvasDefaultUnits: 0.012700000405311584,
    debugCamera: 0,
    debugDimensions: 0,
    hostURL,
    mapleSettings,
    modelPathCanvas: `${hostURL}_3d/canvas1c.glb`,
    modelPathFrame: `${hostURL}_3d/frame3cmatboardcheck2.glb`,
    shadowOffset: 0.33,
    textures: {
      frameBack: "/_3d/_tex/frame-back-texture3_ver2.jpg",
      maple: {
        face: "/_3d/_tex/maple-length-face2.jpg",
        side: "/_3d/_tex/maple-side-length4-1.jpg",
      },
      matboard: "/_3d/_tex/mbtex.jpg",
      paper: "/_3d/_tex/paper.jpg",
      strainer: "/_3d/_tex/wood1.jpg",
      metallic: {
        gold: "/_3d/_tex/gold_frame2.jpg",
        silver: "/_3d/_tex/silver_frame.jpg",
      },
      weathered: {
        black: "/_3d/_tex/weathered_black_texture-1.jpg",
        gray: "/_3d/_tex/weathered_graytexture2-1.jpg",
        walnut: "/_3d/_tex/weathered_walnut-2.jpg",
        white: "/_3d/_tex/weathered-white3.jpg",
        dark: "/_3d/_tex/dark_walnut_textures.jpg",
      },
    },
  },
  renderView: null,
  renderer: null,
  rotationLocked: false,
  scene: null,
  showDimensions: true,
};
